{
  "common.close": "மூடு",
  "common.athleteFallback": "விளையாட்டு வீரர் {id}",
  "splash.title": "{app} — செயல்பாடுகளின் அசைவூட்டக் காட்சி",
  "splash.tagline": "உங்கள்&nbsp;Strava தரவுக்கான அசையும் வரைபடம்",
  "splash.demo": "டெமோ",
  "tab.query.title": "{name} அவர்களின் வரைபடம்",
  "tab.query.heading": "செயல்பாடுகளைத் தேடு:",
  "tab.query.optDays": "சமீபத்திய நாட்கள்",
  "tab.query.optActivities": "சமீபத்திய செயல்பாடுகள்",
  "tab.query.optIds": "செயல்பாட்டு ID-கள்",
  "tab.query.optDates": "தேதி வரம்பு",
  "tab.query.idsPlaceholder": "செயல்பாட்டு ID-களை இங்கே உள்ளிடவும்",
  "tab.query.after": "பின்:",
  "tab.query.before": "முன்:",
  "tab.query.autozoom": "இறக்குமதிக்குப் பின் முடிவுகளுக்குத் தானாக பெரிதாக்கு <i class=\"hf hf-bullseye\"></i>",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> தேடு",
  "tab.query.createAccount": "கணக்கை உருவாக்கவும் மற்றும்/அல்லது உள்நுழையவும்.",
  "tab.query.sports": "விளையாட்டுகள்:",
  "tab.query.allSports": "எல்லா விளையாட்டுகளும்",
  "tab.query.sportsExcept": "இவை தவிர எல்லாம்",
  "tab.query.sportsNone": "எதுவுமில்லை",
  "tab.query.loadingSports": "விளையாட்டுகள் ஏற்றப்படுகின்றன…",
  "tab.query.sportsFailed": "இந்த வரைபடத்தின் விளையாட்டுகளை ஏற்ற முடியவில்லை",
  "tab.query.noSports": "இன்னும் செயல்பாடுகள் இல்லை",
  "tab.activities.title": "காட்டப்படும் செயல்பாடுகள்",
  "tab.activities.clearSelection": "தேர்வை அழி",
  "tab.activities.renderSelected": "தேர்ந்தவற்றைக் காட்டு",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> தேர்வுக்குப் பெரிதாக்கு",
  "tab.controls.title": "அடுக்கு அமைப்புகள்",
  "tab.controls.timescale": "கால அளவு <i>&tau;</i>",
  "tab.controls.timescaleHint": "இயக்க வேகம்",
  "tab.controls.period": "சுற்றுக்காலம் <i>T</i>",
  "tab.controls.periodHint": "செயல்பாடு ~ மாதிரி",
  "tab.controls.dotSize": "புள்ளி அளவு",
  "tab.controls.pathWidth": "பாதை அகலம்",
  "tab.controls.pathWidthHint": "பூஜ்ஜியம் பாதைகளை மறைக்கும்",
  "tab.controls.colors": "நிறங்கள்",
  "tab.controls.colorsHint": "நிறத் தொகுப்பைச் சுழற்று",
  "tab.controls.shadows": "நிழல்கள்",
  "tab.profile.loginTitle": "உள்நுழை",
  "tab.profile.anonNote": "உங்கள் செயல்பாடுகளைப் பார்க்கவும், உங்கள் Heatflask கணக்கை நிர்வகிக்கவும் Strava மூலம் உள்நுழையவும்.",
  "tab.profile.loginLink": "Strava மூலம் உள்நுழை",
  "tab.profile.editOnStrava": "Strava-வில் உங்கள் சுயவிவரத்தைத் திருத்து",
  "tab.profile.indexNote": "விரைவாக அணுக உங்கள் செயல்பாட்டுச் சுருக்கங்களை அட்டவணைப்படுத்துகிறோம்.",
  "tab.profile.viewIndex": "அட்டவணையைப் பார்",
  "tab.profile.sharedMaps": "பகிர்ந்த வரைபடங்கள்",
  "tab.profile.sharedMapsNote": "அணைப்பு: Heatflask-இல் உங்கள் செயல்பாடுகளை நீங்கள் மட்டுமே பார்க்க முடியும். இயக்கம்: உங்கள் வரைபட இணைப்பு உள்ள எவரும் Strava-வில் நீங்கள் பொதுவாக்கிய செயல்பாடுகளைப் பார்க்கலாம். உங்கள் தனிப்பட்ட செயல்பாடுகள் எப்படியும் உங்களுடையவையாகவே இருக்கும். <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">தனியுரிமை எப்படிச் செயல்படுகிறது</a>",
  "tab.profile.logout": "வெளியேறு",
  "tab.profile.deleteAccount": "கணக்கை நீக்கு",
  "tab.profile.deleteConfirm": "உங்கள் Heatflask கணக்கை நீக்கவா?\n\nஇது உங்கள் அட்டவணைப்படுத்திய செயல்பாடுகளை அகற்றி, உங்கள் Strava தரவுக்கான Heatflask அணுகலை ரத்து செய்யும். இதைத் திரும்பப் பெற முடியாது.",
  "tab.profile.languageHeading": "மொழி",
  "tab.profile.languageAuto": "தானியங்கி",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">மொழிபெயர்ப்புகளைத் திருத்த அல்லது புதியவற்றைச் சேர்க்க உதவுங்கள்!</a>",
  "tab.profile.unitsHeading": "அலகுகள்",
  "tab.profile.unitsAuto": "தானியங்கி",
  "tab.profile.unitsMetric": "மெட்ரிக் (கி.மீ, மீ)",
  "tab.profile.unitsImperial": "இம்பீரியல் (மைல், அடி)",
  "tab.profile.textSizeHeading": "எழுத்து அளவு",
  "tab.profile.textSmaller": "சிறியது",
  "tab.profile.textReset": "இயல்பு",
  "tab.profile.textLarger": "பெரியது",
  "tab.profile.mapDefaultsHeading": "வரைபட இயல்புநிலைகள்",
  "tab.profile.mapDefaultsNote": "தன் அமைப்புகளைக் குறிப்பிடாத இணைப்புள்ள வரைபடத்தைத் திறக்கும் ஒவ்வொரு முறையும் இந்த அடிப்படை வரைபடம், நிலப்பரப்பு, அடுக்கு அமைப்புகளுடன் தொடங்கு. நீங்கள் பகிரும் இணைப்புகள் நீங்கள் பார்ப்பதையே சரியாகக் காட்டும்.",
  "tab.profile.mapDefaultsSave": "என் இயல்புநிலையாகச் சேமி",
  "tab.profile.mapDefaultsForget": "மறந்துவிடு",
  "tab.info.title": "தகவல்",
  "tab.info.controlsHeading": "கட்டுப்பாடுகள்",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + இழு",
  "tab.info.shiftDragDesc": "ஒரு பெட்டிக்குள் செயல்பாடுகளைத் தேர்ந்தெடுக்கவும். தொடுதிரையில் முதலில் <i class=\"hf-object-group\"></i> ஐத் தட்டி, பின் ஒரு விரலால் இழுக்கவும். கடைசியாகத் தேர்ந்த செயல்பாட்டின் விவரங்கள் காட்டப்படும், செயல்பாட்டுப் பட்டியலும் அதுவரை உருளும்.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + இழு",
  "tab.info.ctrlDragDesc": "வரைபடத்தை 3D-யில் சுழற்றி சாய்க்கவும், அல்லது இரண்டு விரல்களைப் பயன்படுத்தவும்",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "பக்கப்பட்டியைத் திற அல்லது மூடு",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "முந்தைய அல்லது அடுத்த பக்கப்பட்டித் தாவல்",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "பக்கப்பட்டியை மூடு",
  "tab.info.liveUrlHeading": "நேரடி URL",
  "tab.info.liveUrlDesc": "வரைபடக் காட்சியும் அசைவூட்ட அமைப்புகளும் பக்கத்தின் URL-இல் வைக்கப்படுகின்றன, எனவே நீங்கள் பகிரும் எவரும் அதே காட்சியைப் பார்ப்பார்.",
  "tab.info.videoHeading": "வீடியோ ஏற்றுமதி",
  "tab.info.videoDesc": "<i class=\"hf-video-camera\"></i> பொத்தான் அசைவூட்டத்தை MP4 ஆகப் பதிவுசெய்யும்: அதைத் தட்டி, வரைபடத்தில் நீங்கள் விரும்பும் பகுதியின் மேல் பெட்டியை அமைத்து, பதிவுசெய்ய மீண்டும் தட்டவும். அசைவூட்டத்தின் ஒரு முழுச் சுற்று பதிவாகும், எனவே வீடியோ இடைவெளியின்றி மீண்டும் ஓடும்; {max} வினாடிகளுக்கு (Strava ஏற்கும் மிக நீண்ட வீடியோ) மேற்பட்ட சுற்று {max}-இல் வெட்டப்படும்.",
  "tab.info.contributeHeading": "பங்களி",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> GitHub-இல் ஆதரி",
  "tab.info.contactsHeading": "தொடர்புகள்",
  "map.basemapAndTerrain": "அடிப்படை வரைபடமும் நிலப்பரப்பும்",
  "map.pauseAnimation": "அசைவூட்டத்தை இடைநிறுத்து",
  "map.resumeAnimation": "அசைவூட்டத்தைத் தொடர்",
  "capture.record": "வீடியோ பதிவு ({period} வி. சுற்று)",
  "capture.recordTruncated": "வீடியோ பதிவு (ஒரு சுற்று {period} வி.; முதல் {max} வி. மட்டுமே பதிவாகும்)",
  "capture.recordArea": "பெட்டிக்குள் உள்ள பகுதியைப் பதிவுசெய்",
  "capture.stop": "பதிவை நிறுத்து",
  "capture.selectionTooSmall": "தேர்வு மிகச் சிறியது",
  "capture.saved": "{name} சேமிக்கப்பட்டது ({size})",
  "capture.cancelled": "பதிவு ரத்துசெய்யப்பட்டது",
  "capture.failed": "பதிவு தோல்வி: {error}",
  "capture.loadingEncoder": "என்கோடர் ஏற்றப்படுகிறது…",
  "capture.waitingForMap": "வரைபடம் ஏறக் காத்திருக்கிறது…",
  "capture.encoding": "என்கோட் ஆகிறது… {percent}%",
  "capture.finalizing": "நிறைவுசெய்கிறது…",
  "share.title": "இந்த வரைபடத்தின் இணைப்பைப் பகிர்",
  "share.copied": "இணைப்பு நகலெடுக்கப்பட்டது",
  "share.copiedUnshared": "இணைப்பு நகலெடுக்கப்பட்டது — ஆனால் உங்கள் வரைபடம் பகிரப்படவில்லை, அதனால் வேறு யாரும் அதைத் திறக்க முடியாது. மாற்ற “பகிர்ந்த வரைபடங்கள்” என்பதை இயக்கவும்.",
  "share.unshared": "உங்கள் வரைபடம் பகிரப்படவில்லை, அதனால் வேறு யாரும் இந்த இணைப்பைத் திறக்க முடியாது. மாற்ற “பகிர்ந்த வரைபடங்கள்” என்பதை இயக்கவும்.",
  "share.copyThis": "இந்த இணைப்பை நகலெடுக்கவும்:",
  "update.available": "Heatflask இன் புதிய பதிப்பு கிடைக்கிறது.",
  "update.reload": "மீண்டும் ஏற்று",
  "import.title": "இறக்குமதி ஆகிறது",
  "import.stop": "நிறுத்து",
  "import.stopping": "நிறுத்துகிறது…",
  "import.contacting": "Strava-வைத் தொடர்புகொள்கிறது…",
  "import.countOf": "செயல்பாடுகள்: {total}-இல் {received}",
  "import.count": "செயல்பாடுகள்: {received}",
  "import.waitStrava": "Strava பதிவிறக்க வரம்பால் {time} வரை இடைநிறுத்தப்பட்டுள்ளது. இந்தப் பக்கத்தைத் திறந்தே வையுங்கள்; மீண்டும் ஏற்றினால் வேகமாகாது.",
  "import.waitRationed": "இன்றைய வேகமான பதிவிறக்கங்கள் முடிந்துவிட்டன. மீதி {time} முதல் மெதுவாகத் தொடரும். இந்தப் பக்கத்தைத் திறந்தே வையுங்கள்.",
  "import.dailyLimit": "Strava தினசரி பதிவிறக்க வரம்பு முடிந்துவிட்டது. {time}க்குப் பிறகு மீண்டும் முயலுங்கள்.",
  "import.dailyRationed": "இன்றைக்கான உங்கள் Strava பதிவிறக்கப் பங்கு முடிந்துவிட்டது. {time}க்குப் பிறகு மீண்டும் முயலுங்கள்.",
  "import.noActivitiesYet": "உங்கள் Strava கணக்கில் இன்னும் எந்தச் செயல்பாடும் இல்லை. Strava-வில் ஒன்றைப் பதிவுசெய்யுங்கள் அல்லது பதிவேற்றுங்கள், அது இங்கே தோன்றும்.",
  "table.noActivities": "செயல்பாடுகள் இல்லை",
  "table.untitled": "(தலைப்பு இல்லை)",
  "activities.pageTitle": "{app} — செயல்பாட்டு அட்டவணை",
  "activities.heading": "செயல்பாட்டு அட்டவணை",
  "activities.fetching": "செயல்பாடுகளைப் பெறுகிறது...",
  "activities.rateLimit": "Strava கோரிக்கை வரம்பு எட்டப்பட்டது; {time}-க்குத் தொடரும்",
  "activities.noData": "மன்னிக்கவும், தரவு இல்லை &#128577;",
  "activities.colServerCache": "தடம் சேவையகத்தில் சேமிக்கப்பட்டது (Mongo)",
  "activities.colBrowserCache": "தடம் இந்த உலாவியில் சேமிக்கப்பட்டது",
  "activities.cachedServer": "{id}-இன் தடம் சேவையகத்தில் சேமிக்கப்பட்டுள்ளது",
  "activities.notCachedServer": "{id}-இன் தடம் சேவையகத்தில் சேமிக்கப்படவில்லை",
  "activities.cachedBrowser": "{id}-இன் தடம் இந்த உலாவியில் சேமிக்கப்பட்டுள்ளது",
  "activities.notCachedBrowser": "{id}-இன் தடம் இந்த உலாவியில் சேமிக்கப்படவில்லை",
  "sport.AlpineSki": "ஆல்பைன் பனிச்சறுக்கு",
  "sport.BackcountrySki": "மலைப்பகுதி பனிச்சறுக்கு",
  "sport.Badminton": "பூப்பந்து",
  "sport.Basketball": "கூடைப்பந்து",
  "sport.Canoeing": "கேனோ படகோட்டம்",
  "sport.Cricket": "கிரிக்கெட்",
  "sport.Crossfit": "கிராஸ்ஃபிட்",
  "sport.Dance": "நடனம்",
  "sport.EBikeRide": "மின் மிதிவண்டி பயணம்",
  "sport.Elliptical": "எலிப்டிகல்",
  "sport.EMountainBikeRide": "மின் மலை மிதிவண்டி பயணம்",
  "sport.Golf": "கோல்ஃப்",
  "sport.GravelRide": "சரளைச் சாலை பயணம்",
  "sport.Handcycle": "கை மிதிவண்டி",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "மலையேற்றம்",
  "sport.IceSkate": "பனிச்சறுக்கு ஸ்கேட்டிங்",
  "sport.InlineSkate": "இன்லைன் ஸ்கேட்டிங்",
  "sport.Kayaking": "கயாக்கிங்",
  "sport.Kitesurf": "காத்தாடி அலைச்சறுக்கு",
  "sport.MountainBikeRide": "மலை மிதிவண்டி பயணம்",
  "sport.NordicSki": "நார்டிக் பனிச்சறுக்கு",
  "sport.Padel": "பேடல்",
  "sport.PhysicalTherapy": "இயன்முறை மருத்துவம்",
  "sport.Pickleball": "பிக்கிள்பால்",
  "sport.Pilates": "பிலாட்டிஸ்",
  "sport.Racquetball": "ராக்கெட்பால்",
  "sport.Ride": "மிதிவண்டி பயணம்",
  "sport.RockClimbing": "பாறை ஏறுதல்",
  "sport.RollerSki": "ரோலர் ஸ்கி",
  "sport.Rowing": "படகு வலித்தல்",
  "sport.Run": "ஓட்டம்",
  "sport.Sail": "பாய்மரப் படகோட்டம்",
  "sport.Skateboard": "ஸ்கேட்போர்டு",
  "sport.Snowboard": "ஸ்னோபோர்டு",
  "sport.Snowshoe": "பனிக்காலணி நடை",
  "sport.Soccer": "கால்பந்து",
  "sport.Squash": "ஸ்குவாஷ்",
  "sport.StairStepper": "படிக்கட்டு இயந்திரம்",
  "sport.StandUpPaddling": "நின்று துடுப்பு போடுதல்",
  "sport.Surfing": "அலைச்சறுக்கு",
  "sport.Swim": "நீச்சல்",
  "sport.TableTennis": "மேசைப்பந்து",
  "sport.Tennis": "டென்னிஸ்",
  "sport.TrailRun": "பாதை ஓட்டம்",
  "sport.Velomobile": "வெலோமொபைல்",
  "sport.VirtualRide": "மெய்நிகர் மிதிவண்டி பயணம்",
  "sport.VirtualRow": "மெய்நிகர் படகு வலித்தல்",
  "sport.VirtualRun": "மெய்நிகர் ஓட்டம்",
  "sport.Volleyball": "கைப்பந்து",
  "sport.Walk": "நடை",
  "sport.WeightTraining": "எடைப் பயிற்சி",
  "sport.Wheelchair": "சக்கர நாற்காலி",
  "sport.Windsurf": "காற்றலைச்சறுக்கு",
  "sport.Workout": "உடற்பயிற்சி",
  "sport.Yoga": "யோகா"
}
